import React from 'react';
import Grid from 'atoms/Layout/Grid/Grid';
import Stack from 'atoms/Layout/Stack/Stack';
import FooterForm from 'molecules/Footer/FooterForm';
import FooterLegal from 'molecules/Footer/FooterLegal';
import FooterLinks from 'molecules/Footer/FooterLinks';
import FooterLinksMobile from 'molecules/Footer/FooterLinksMobile';
import { MainLayout } from 'molecules/Header/Header/Header';

interface FooterProps {
  type: MainLayout;
}

const Footer = ({ type }: FooterProps): JSX.Element => {
  return (
    <Stack
      direction='column'
      gap='spacing-7xl'
      background='bg-primary-solid'
      align='stretch'
      padding={['spacing-7xl', 'spacing-none', 'spacing-6xl', 'spacing-none']}
      dataCy='footer'
    >
      <Grid
        totalColumns={12}
        totalColumnsLg={1}
        maxWidth='width-3xl'
        maxWidthLg='width-md'
        padding={['spacing-none', 'spacing-4xl']}
        margin={['spacing-none', 'spacing-auto']}
      >
        <FooterLinks />
        <FooterForm type={type} />
        <FooterLinksMobile />
      </Grid>
      <FooterLegal />
    </Stack>
  );
};

export default Footer;
